<template>
  <div class="login">
    <sn-breadcrumb :breadcrumb="[{
      title: '用户登录'
    }]"></sn-breadcrumb>
    <div class="sn-f-c-c operate">
      <div id="wx" class="sn-f-col-c-c" :style="{
        'background-color': hosWechatAppId ? color.white : color.transparent
      }"></div>
      <div class="sn-f-col-c-c handle">
        <div class="sn-f-b-c sn-pointer pattern">
          <div class="sn-f-c-c pattern-single" :class="{'pattern-interaction': loginPattern === '1'}" @click="loginPattern = '1';">密码登录</div>
          <div class="sn-f-c-c pattern-single" :class="{'pattern-interaction': loginPattern === '2'}" @click="loginPattern = '2';">动态码登录</div>
        </div>
        <div class="main">
          <div class="sn-f-b-c main-line">
            <div class="sn-f-e-c main-title">{{ loginPattern === '1' ? '用户名' : '手机号' }}：</div>
            <div class="sn-f-1 main-input">
              <input placeholder="请输入您的手机号" maxlength="11" v-model="user.phone" @keydown.enter="login();"/>
            </div>
          </div>
          <div class="sn-f-b-c main-line" v-if="loginPattern === '1'">
            <div class="sn-f-e-c main-title">密码：</div>
            <div class="sn-f-1 main-input">
              <input placeholder="请输入您的密码" maxlength="16" :type="hide ? 'password' : 'text'" v-model="user.password" @keydown.enter="login();"/>
              <div class="iconfont" :class="hide ? 'icon-yincang' : 'icon-kekan'" @click="hide = !hide;"></div>
            </div>
          </div>
          <div class="sn-f-b-c main-line" v-else-if="loginPattern === '2'">
            <div class="sn-f-e-c main-title">动态码：</div>
            <div class="sn-f-b-c sn-f-1 main-input">
              <input class="sn-f-1" placeholder="请输入您的动态码" maxlength="6" v-model="user.code" @keydown.enter="login();"/>
              <div class="sn-f-c-c sn-pointer code" :class="{'code-default': serial < 60}" @click="login_mixin_sendCode(user.phone, '3');">{{ serial < 60 ? '重新获取(' + serial + ')s' : '获取动态码' }}</div>
            </div>
          </div>
        </div>
        <div class="sn-f-b-c subsidiary">
          <div class="sn-pointer sn-fc-main" @click="login_mixin_navigateUrl('/login/register', '', {
            mode: '2'
          });">忘记密码？</div>
          <div class="sn-pointer sn-f-e-c" v-if="loginPattern === '1'" @click="isCookie = !isCookie;">
            <div class="iconfont" :class="{
              'icon-fangkuangweixuanzhong': !isCookie,
              'icon-a-jianqu5 sn-fc-main': isCookie
            }"></div>
            <div :class="{'sn-fc-main': isCookie}">记住密码</div>
          </div>
        </div>
        <div class="sn-f-b-c interaction">
          <div class="sn-f-c-c sn-pointer interaction-single interaction-default" @click="login_mixin_navigateUrl('/login/register', '', {
            mode: '1'
          });">注册</div>
          <div class="sn-f-c-c sn-pointer interaction-single" @click="login();">登录</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import LoginMixin from '@/pages/login/login-mixin';
import * as Messages from '@/common/utils/messages';

export default {
  mixins: [LoginMixin],
  data() {
    return {
      color: self.$sn.color,
      pageParams: {},
      user: {
        phone: '',
        password: '',
        code: ''
      },
      hide: true,
      isCookie: false,
      hosWechatAppId: self.$sn.getConfig('hosWechatAppId'),
      loginPattern: self.$sn.getConfig('loginPattern')
    };
  },
  watch: {
    '$route.query.code': {
      handler: function() {
        this.pageParams = this.$route.query;
        if (this.pageParams.login === 'wx' && this.pageParams.code) {
          this.sendBackWx();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const handle = document.querySelector('.handle');
      if (handle) {
        document.getElementById('wx').style.width = handle.clientHeight + 'px';
        document.getElementById('wx').style.height = handle.clientHeight + 'px';
        this.initialWx();
      }
    });
  },
  created: function() {
    document.title = '用户登录';
    this.$route.meta.title = '用户登录';
    this.initialUser();
  },
  methods: {
    // 初始化用户之前是否使用记住密码
    initialUser() {
      if (!this.$sn.validate.empty(this.$sn.utils.getHospitalCookie('LoginUserCookie'))) {
        const c = this.$sn.utils.getHospitalCookie('LoginUserCookie');
        if (c.phone) this.user.phone = c.phone;
        if (c.password) this.user.password = c.password;
        this.isCookie = this.user.phone && this.user.password;
      }
    },
    // 初始化微信扫码登录二维码
    initialWx() {
      if (this.hosWechatAppId) {
        const domain = window.location.hostname;
        const compare = {
          // 山东省立医院
          'hospital-pc.sph.com.cn': 'SDSL2015',
          // 山东大学齐鲁医院
          'reg.qiluhospital.com': '49b83c26-a256-4088-b8a8-af3027d83793',
          // 济宁市兖州区人民医院
          'yygh.yzph.org': '25de9052-9ba5-4fce-9f91-3cf79bf93700'
        };
        let hosId = '';
        if (!compare[domain]) {
          hosId = '?hosId=' + this.$sn.utils.getHospitalId();
        }
        /* eslint-disable */
        var qr = new WxLogin({
          self_redirect: false,
          id: 'wx',
          appid: this.hosWechatAppId,
          scope: 'snsapi_login',
          redirect_uri: encodeURIComponent(this.$sn.utils.getProtocol() + '//' + domain + '/' + hosId + '#/login?login=wx&'),
          state: '',
          style: '',
          href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30K'
        });
        /* eslint-enable */
      }
    },
    // 接受微信扫码登录回调并进行登录
    sendBackWx() {
      const history = this.$sn.utils.getHospitalSessionStorage('WxCode') || [];
      if (!history.includes(this.pageParams.code)) {
        history.push(this.pageParams.code);
        this.$sn.utils.setHospitalSessionStorage('WxCode', history);
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: Swagger.qrLogin,
          query: {
            hosId: this.$sn.utils.getHospitalId(),
            platformType: this.$sn.utils.getPlatformType(),
            projectType: '',
            code: this.pageParams.code
          },
          method: 'POST'
        }).then(result => {
          this.$sn.assembly.loading(false);
          this.suffixLogin('0', result);
        });
      }
    },
    async login() {
      if (!this.$sn.validate.phone(this.user.phone)) {
        this.$sn.assembly.modal({
          caption: Messages.C013,
          isCancel: false
        });
        return false;
      }
      if (this.loginPattern === '1' && !this.$sn.validate.password(this.user.password)) {
        this.$sn.assembly.modal({
          caption: Messages.C033,
          isCancel: false
        });
        return false;
      }
      else if (this.loginPattern === '2' && !this.$sn.validate.code(this.user.code)) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.C031, ['您的动态码']),
          isCancel: false
        });
        return false;
      }
      this.$sn.assembly.loading(true);
      const verify = await this.login_mixin_verifyRegister(this.user.phone);
      this.$sn.assembly.loading(false);
      if (verify.code === 0) {
        if (verify.data) {
          let params = {};
          if (this.loginPattern === '1') {
            params = {
              url: Swagger.loginByPassword,
              method: 'POST',
              data: JSON.stringify({
                hosId: this.$sn.utils.getHospitalId(),
                mobile: this.user.phone,
                password: this.user.password,
                platformType: this.$sn.utils.getPlatformType(),
                projectType: '',
                userId: this.$sn.utils.getOpenIdByPhone(this.user.phone)
              })
            };
          }
          else if (this.loginPattern === '2') {
            params = {
              url: Swagger.loginByCode,
              method: 'POST',
              data: JSON.stringify({
                hosId: this.$sn.utils.getHospitalId(),
                mobile: this.user.phone,
                platformType: this.$sn.utils.getPlatformType(),
                projectType: '',
                userId: this.$sn.utils.getOpenIdByPhone(this.user.phone),
                verifyCode: this.user.code
              })
            };
          }
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest(params).then(result => {
            this.$sn.assembly.loading(false);
            this.suffixLogin(this.loginPattern, result);
          });
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C032,
            isCancel: false
          });
        }
      }
      else {
        this.$sn.assembly.modal({
          caption: verify.msg,
          isCancel: false
        });
      }
    },
    /*
    登录结果回调处理
    type[string]：0：微信扫码登录；1：密码登录；2：动态码登录
     */
    suffixLogin(type, result) {
      let restart = true;
      if (result) {
        if (result.code === 0) {
          if (result.data) {
            restart = false;
            // 密码登录-记住密码
            if (type === '1') {
              const c = {
                phone: '',
                password: ''
              };
              if (this.isCookie) {
                c.phone = this.user.phone;
                c.password = this.user.password;
              }
              this.$sn.utils.setHospitalCookie('LoginUserCookie', c);
            }
            this.login_mixin_suffixLogin(result.data);
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C002,
              isCancel: false
            });
          }
        }
        else {
          if (result.code === 48814) {
            if (this.$sn.format.getQuality(result, 'data.snCode')) {
              this.login_mixin_navigateUrl('/login/register', '', {
                snCode: result.data.snCode,
                mode: '0'
              });
            }
            else {
              this.$sn.assembly.modal({
                caption: this.$sn.format.caption(Messages.C018, ['snCode']),
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: result.msg,
              isCancel: false
            });
          }
        }
      }
      else {
        this.$sn.assembly.modal({
          caption: Messages.C001,
          isCancel: false
        });
      }
      if (restart) this.initialWx();
    }
  }
};
</script>
<style lang="scss" scoped>
.login {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-image: $main12;

  .sn-breadcrumb {
    padding: 40px 20px 0;
  }

  .operate {
    padding-top: 40px;

    #wx {
      overflow: hidden;
      border-radius: 8px;
      margin-right: 20px;
    }

    .handle {
      overflow: hidden;
      width: 450px;
      background-color: $white1;
      border-radius: 8px;
      padding: 40px 20px;

      .pattern {
        @include fs(16);

        overflow: hidden;
        width: 100%;
        height: 40px;
        background-color: $background2;
        color: $text1;
        border-radius: 5px;

        &-single {
          flex: 1;
          height: 40px;
        }

        &-interaction {
          background-color: $main;
          color: $white;
        }
      }

      .main {
        overflow: hidden;
        width: 100%;
        margin-top: 20px;

        &-line {
          @include fs(16);

          width: 100%;
          height: 50px;
          margin-top: 10px;

          &:first-child {
            margin-top: 0;
          }

          .main-title {
            width: 20%;
          }

          .main-input {
            position: relative;

            input {
              @include fs(16);

              outline: none;
              width: 100%;
              height: 40px;
              border: 1px solid $border1;
              border-radius: 5px;
              padding: 0 10px;

              &::-webkit-input-placeholder {
                opacity: 1 !important;
                color: $text3;
              }

              &:focus {
                border: 1px solid $main;
              }
            }

            .iconfont {
              font-size: 14px;
              color: $text3;
              position: absolute;
              top: 50%;
              right: 10px;
              transform: translateY(-50%);
            }

            .icon-yincang {
              font-size: 10px;
            }

            .code {
              @include fs(16);

              width: 140px;
              height: 40px;
              background-color: $white;
              color: $main;
              border: 1px solid $main;
              border-radius: 5px;
              margin-left: 8px;

              &-default {
                color: $text3;
                border: 1px solid $border1;
              }
            }
          }
        }
      }

      .subsidiary {
        @include fs(16);

        overflow: hidden;
        width: 100%;
        padding: 0 20px;
        margin-top: 10px;

        .iconfont {
          font-size: 16px;
          color: $black;
          margin-right: 8px;
        }
      }

      .interaction {
        width: 100%;
        height: 40px;
        margin-top: 20px;

        &-single {
          @include fs(16);

          flex: 1;
          height: 40px;
          background-color: $main;
          color: $white;
          border-radius: 5px;

          &:first-child {
            margin-right: 40px;
          }
        }

        &-default {
          background-color: $background2;
          color: $black;
        }
      }
    }
  }
}
</style>
